module.exports = __webpack_public_path__ + "static/img/bg.ceb24920.png";